// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-header .export__icon{filter:none!important}.block-header__switch .the-switch.small .ant-switch{width:32px;min-width:32px;height:20px}.block-header__switch .the-switch.small .ant-switch:after{width:16px;height:16px;top:2px;left:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
